import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { get } from "lodash";
import Swal from "sweetalert2";

import SettingModel from "../../models/SettingModel";
import TextInput from "../inputs/TextInput";

export default function TransitionsModal(props) {
  const [loading, setLoading] = useState(false);

  async function create(payload) {
    try {
      setLoading(true);

      const res = await SettingModel.createMunicipality({
        action: "add",
        ...payload,
      });

      await props.fetchData();

      setLoading(false);

      props.closemodal(true);
    } catch (error) {
      console.log("error => ", error);
      props.closemodal(false);
    }
  }

  const formik = useFormik({
    initialValues: {
      Municipality: get("", "Municipality", ""),
      Mun_lat: get("", "Mun_lat", ""),
      Mun_lng: get("", "Mun_lng", ""),
    },
    validationSchema: Yup.object({
      Municipality: Yup.string().required("Required"),
      Mun_lat: Yup.string().required("Required"),
      Mun_lng: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      // console.log("Values => ", values);
      create(values);
    },
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between align-items-center mb-5">
            <div>
              <h5>Add New Municipality</h5>
            </div>
            <div>
              <button className="btn btn-sm btn-success" type="submit">
                {loading ? (
                  <div class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>

          <div className="col-md-4">
            <TextInput
              id="property-Municipality"
              label="Municipality"
              variant="outlined"
              getValue={(value) => formik.setFieldValue("Municipality", value)}
              value={formik.values.Municipality}
              onBlur={() => formik.setFieldTouched("Municipality")}
              error={
                Boolean(formik.errors.Municipality) &&
                formik.touched.Municipality
              }
              errorMsg={formik.errors.Municipality}
              type="text"
            />
          </div>
          <div className="col-md-4">
            <TextInput
              id="property-Mun_lat"
              label="Latitude"
              variant="outlined"
              getValue={(value) => formik.setFieldValue("Mun_lat", value)}
              value={formik.values.Mun_lat}
              onBlur={() => formik.setFieldTouched("Mun_lat")}
              error={Boolean(formik.errors.Mun_lat) && formik.touched.Mun_lat}
              errorMsg={formik.errors.Mun_lat}
              type="text"
            />
          </div>
          <div className="col-md-4">
            <TextInput
              id="property-Mun_lng"
              label="Longitude"
              variant="outlined"
              getValue={(value) => formik.setFieldValue("Mun_lng", value)}
              value={formik.values.Mun_lng}
              onBlur={() => formik.setFieldTouched("Mun_lng")}
              error={Boolean(formik.errors.Mun_lng) && formik.touched.Mun_lng}
              errorMsg={formik.errors.Mun_lng}
              type="text"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
